export default function ({ route, store, redirect }) {
  console.log('version 20210830-001')
}
